/** Some endpoints wrap the payload under `data`; tolerate both shapes. */
export function unwrapData(raw: unknown): unknown {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return raw.data;
  }
  return raw;
}
